/**
* DevExpress Dashboard (_tab-container-item.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { PropertyCategory } from '../../../metadata/_base-metadata';
import { dashboardItemSerializationsInfo } from '../../metadata/_dashboard-item';
export let tabPages = { propertyName: 'tabPages', modelName: 'Pages', array: true, category: PropertyCategory.NoUpdate };
export let tabContainerItemSerializationInfo = dashboardItemSerializationsInfo.concat([tabPages]);
